import React, { useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { useQnAContext } from './contexts/QnAContext';

export function QnANotificationAlert() {
  const { notification, dismissNotification } = useQnAContext();

  useEffect(() => {
    if (notification?.autoHide && notification.timeout) {
      const timer = setTimeout(() => {
        dismissNotification();
      }, notification.timeout);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [notification, dismissNotification]);

  if (!notification) {
    return null;
  }

  const getVariant = () => {
    switch (notification.type) {
      case 'success':
        return 'success';
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  };

  return (
    <Alert
      variant={getVariant()}
      className="mb-2"
      dismissible
      onClose={dismissNotification}
    >
      {notification.message}
    </Alert>
  );
}
